"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUuid = exports.getModule = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const bit_utils_environment_1 = require("@gcloud-npm/bit.utils.environment");
const bit_utils_common_1 = require("@gcloud-npm/bit.utils.common");
const Page_1 = __importDefault(require("./Page"));
const LoadingMessage = () => null;
const getModule = (myModules, key) => {
    const currentModule = myModules.find((module) => module.id === key);
    return currentModule.loader;
};
exports.getModule = getModule;
const generateSingleUuid = () => Math.random().toString(36).substr(2, 9);
const generateUuid = () => {
    return (generateSingleUuid() +
        '-' +
        generateSingleUuid() +
        '-' +
        generateSingleUuid() +
        '-' +
        generateSingleUuid() +
        '-' +
        generateSingleUuid() +
        '-' +
        generateSingleUuid());
};
exports.generateUuid = generateUuid;
const createRouter = (urlLibrary, modulesLibrary, contextData, projectId = '') => {
    const { name: enviromentKey } = (0, bit_utils_environment_1.findOutEnv)();
    const pageList = urlLibrary.map((item) => item);
    return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(LoadingMessage, null) },
        react_1.default.createElement(react_router_dom_1.Switch, null, pageList.map((pageData) => {
            if (pageData) {
                const { loader, pathName, exact, redirection, onlyDev, pageId, seoCustomValue, isBuyProcess, loggedPage, differentLoginStatusRedirect, } = pageData;
                let path2Use = pathName;
                if (pathName && pathName[enviromentKey]) {
                    path2Use = pathName[enviromentKey];
                }
                const component = (0, exports.getModule)(modulesLibrary, loader);
                let allowToShow = true;
                if (onlyDev) {
                    allowToShow = enviromentKey === 'dev';
                }
                if (allowToShow) {
                    // Redirect when login status is different to config
                    let url2go = null;
                    let loginStatusRedirect2Use = null;
                    if (differentLoginStatusRedirect &&
                        differentLoginStatusRedirect[enviromentKey]) {
                        loginStatusRedirect2Use =
                            differentLoginStatusRedirect[enviromentKey];
                    }
                    if (contextData && loginStatusRedirect2Use) {
                        if ((loggedPage && !contextData.userType) ||
                            (!loggedPage && contextData.userType)) {
                            url2go = loginStatusRedirect2Use;
                            if (document &&
                                document.location &&
                                document.location.search) {
                                const searchParams = document.location.search;
                                if (searchParams.indexOf('spaRedirect') === -1) {
                                    url2go = `${url2go}${searchParams}&spaRedirect=true`;
                                }
                                else {
                                    url2go = `${url2go}${searchParams}`;
                                }
                            }
                            else if (!document.location.search) {
                                url2go = `${url2go}?spaRedirect=true`;
                            }
                        }
                    }
                    // END Redirect when login status is different to config
                    if (component && !redirection && !url2go) {
                        return path2Use.map((currentPathName) => {
                            return (react_1.default.createElement(react_router_dom_1.Route, { exact: exact, key: `route-${currentPathName}-${(0, bit_utils_common_1.giveRandomNumber)(1, 99)}`, path: currentPathName, render: (props) => {
                                    const ComponentPage = component;
                                    return (react_1.default.createElement(react_1.Fragment, { key: `fragment-${currentPathName}-${(0, bit_utils_common_1.giveRandomNumber)(1, 99)}` },
                                        react_1.default.createElement(Page_1.default, Object.assign({}, props, { key: `fragment-${currentPathName}-${(0, bit_utils_common_1.giveRandomNumber)(1, 99)}`, projectId: projectId, pageId: pageId, gaPageId: (0, exports.generateUuid)(), seoCustomValue: seoCustomValue, context: contextData, isBuyProcess: isBuyProcess })),
                                        react_1.default.createElement(ComponentPage, Object.assign({}, props, { projectId: projectId }))));
                                } }));
                        });
                    }
                    if (redirection) {
                        return (react_1.default.createElement(react_router_dom_1.Route, { key: `redirect${path2Use}`, exact: exact, path: `${path2Use}`, render: () => react_1.default.createElement(react_router_dom_1.Redirect, { to: redirection }) }));
                    }
                    if (url2go) {
                        let mustInjectRedirection = false;
                        let myCurrentLocation = document.location.pathname;
                        if (myCurrentLocation && myCurrentLocation.length) {
                            const lastChar = myCurrentLocation[myCurrentLocation.length - 1];
                            if (lastChar !== '/') {
                                myCurrentLocation = `${myCurrentLocation}/`;
                            }
                        }
                        path2Use.forEach((itemPath) => {
                            if (!mustInjectRedirection &&
                                itemPath === myCurrentLocation) {
                                mustInjectRedirection = true;
                            }
                        });
                        if (!mustInjectRedirection) {
                            return null;
                        }
                        return (react_1.default.createElement(react_router_dom_1.Route, { key: `redirect${url2go}`, exact: exact, path: myCurrentLocation, render: () => react_1.default.createElement(react_router_dom_1.Redirect, { to: url2go }) }));
                    }
                    return null;
                }
            }
            return null;
        }))));
};
exports.default = createRouter;
//# sourceMappingURL=createRouter.js.map